const StorePlaceGridPluginSettings: IPluginSettings = {
    name: 'Места хранения',
    mnemocode: 'store_place_plugin',
    permission: 'StorePlace',
    columns: [{
        order: 0,
        propertyName: 'name',
        propertyType: 'string',
        displayName: 'Наименование',
        visibility: true,
        width: 150
    }, {
        order: 1,
        propertyName: 'mnemocode',
        propertyType: 'string',
        displayName: 'Мнемокод',
        visibility: true,
        width: 150
    }, {
        order: 2,
        propertyName: 'description',
        propertyType: 'string',
        displayName: 'Описание',
        visibility: true,
        width: 150
    }, {
        order: 3,
        propertyName: 'dateModified',
        propertyType: 'datetime',
        displayName: 'Дата изменения',
        visibility: true,
        width: 157
    }, {
        order: 4,
        propertyName: 'dateDeleted',
        propertyType: 'datetime',
        displayName: 'Дата удаления',
        visibility: true,
        width: 157
    }, {
        order: 5,
        propertyName: 'dateCreated',
        propertyType: 'datetime',
        displayName: 'Дата создания',
        visibility: true,
        width: 157
    }, {
        order: 6,
        propertyName: 'deleted',
        propertyType: 'boolean',
        displayName: 'Удаленные',
        visibility: false,
        width: 157
    }
    ],
}

export default StorePlaceGridPluginSettings